(() => {
  if (customElements.get('product-list-columns')) {
    return;
  }

  class ProductListColumns extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        perPage: 3,
        gap: 16,
        arrows: false,
        pagination: true,
        breakpoints: {
          767: {
            perPage: 1,
            padding: { right: '28%' },
            gap: 12,
          }
        }
      };
    }

    connectedCallback() {
      this.slider = new Splide(this, this.options).mount();

      const prev = this.querySelector('.section-plc__btn-prev');
      const next = this.querySelector('.section-plc__btn-next');

      if (prev) prev.addEventListener('click', () => this.slider.go('<'));
      if (next) next.addEventListener('click', () => this.slider.go('>'));

      const updateArrows = () => {
        const index = this.slider.index;
        const last = this.slider.length - this.slider.options.perPage;
        if (prev) prev.style.visibility = index === 0 ? 'hidden' : 'visible';
        if (next) next.style.visibility = index >= last ? 'hidden' : 'visible';
      };

      this.slider.on('moved', updateArrows);
      updateArrows();
    }
  }

  customElements.define('product-list-columns', ProductListColumns);
})();
